import { AbstractControl } from '@angular/forms';

export class ErrorMessage {
  static getTextMandatory(label: string): string {
    return `o preenchimento do campo ${label} é obrigatório`;
  }

  static forgotFill(label: string): string {
    return `Faltou informar ${label}`;
  }

  static getTextInvalid(label: string, showLabelName: boolean = false): string {
    if (showLabelName) {
      return `o preenchimento do campo ${label} é obrigatório ou está com um valor inválido`;
    } else {
      return `você precisa preencher este campo, ou confira se os dados digitados estão corretos`;
    }
  }

  static getTextInvalidValue(label: string): string {
    return `o preenchimento do campo ${label} está com um valor inválido`;
  }

  /**
   * Erros genéricos para campos de texto (nome, etc.)
   */
static getTextFieldError(
  control: AbstractControl | null,
  label: string
): string {

  // só mostra erro se o campo estiver inválido E (dirty ou touched)
  if (!control || !(control.invalid && (control.dirty || control.touched))) {
    return '';
  }
const minLengthError = control.getError('minlength');
  // 1) Campo vazio
  if (control.hasError('required')) {
    return `Faltou digitar ${label}`;
  }

  // 2) Erros de mínimo de caracteres (genérico + fullName + razão social)
  if (
    control.hasError('textMinChars') ||
    control.hasError('fullNameMinChars') ||
    control.hasError('corporateNameMinLength') ||
    minLengthError
  ) {
    return `Termine de digitar ${label}`;
  }

  // 3) Erros de caracteres inválidos (genérico + fullName + razão social)
  if (
    control.hasError('textInvalidChars') ||
    control.hasError('fullNameInvalidChars') ||
    control.hasError('corporateNameInvalidChars')
  ) {
    return 'Use apenas letras, sem números ou caracteres especiais';
  }

  // fallback genérico
  return this.getTextInvalid(label);
}

  /**
   * Erros específicos para campos de DATA (ex.: data de nascimento)
   */
  static getDateFieldError(
    control: AbstractControl | null,
    label: string
  ): string {
    // só mostra erro se o campo estiver inválido E (dirty ou touched)
    if (!control || !(control.invalid && (control.dirty || control.touched))) {
      return '';
    }

    // 1) Campo vazio
    if (control.hasError('required')) {
      return `Faltou digitar ${label}`;
    }

    // 2) Caracteres mínimos (8 caracteres)
    if (control.hasError('minlength')) {
      return `Termine de digitar ${label}`;
    }

    // 5) Formato inválido (letras/especiais)
    if (control.hasError('pattern')) {
      return 'Use apenas números, sem letras ou caracteres especiais';
    }

    // 4) Data inválida ou fora da faixa (inclui hoje/futuro)
    if (control.hasError('invalidDate')) {
      return 'Informe uma data válida';
    }

     if (control.hasError('futureDate')) {
      const capitalizedLabel = this.capitalizeFirstLetter(label);
      return `${capitalizedLabel} não pode ser maior que a data atual`;
    }

    // fallback genérico
    return 'Informe uma data válida';
  }



   static getBirthDateFieldError(
    control: AbstractControl | null,
    label: string
  ): string {
    // só mostra erro se o campo estiver inválido E (dirty ou touched)
    if (!control || !(control.invalid && (control.dirty || control.touched))) {
      return '';
    }

    // 1) Campo vazio
    if (control.hasError('required')) {
      return `Faltou digitar ${label}`;
    }

    // 2) Caracteres mínimos (8 caracteres)
    if (control.hasError('minlength')) {
      return `Termine de digitar ${label}`;
    }

    // 5) Formato inválido (letras/especiais)
    if (control.hasError('pattern')) {
      return 'Use apenas números, sem letras ou caracteres especiais';
    }

    // 4) Data inválida ou fora da faixa (inclui hoje/futuro)
    if (control.hasError('invalidDate')) {
      return 'Informe uma data válida';
    }

     if (control.hasError('futureDate')) {
      const capitalizedLabel = this.removeFirstLetter(label);
      return `Informe uma ${capitalizedLabel} válida`;
    }

    // fallback genérico
    return 'Informe uma data válida';
  }

  private static removeFirstLetter(text: string): string {
  if (!text) return text;
  return text.slice(1); // ou text.substring(1);
}

  private static capitalizeFirstLetter(text: string): string {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
}

  /**
   * Erros específicos para campos de E-MAIL
   */
  static getEmailFieldError(
    control: AbstractControl | null,
    label: string
  ): string {
    // só mostra erro se o campo estiver inválido E (dirty ou touched)
    if (!control || !(control.invalid && (control.dirty || control.touched))) {
      return '';
    }

    // 1) Campo vazio
    if (control.hasError('required')) {
      return `Faltou digitar ${label}`;
    }

    // 2) E-mail inválido (validador customizado -> { email: true })
    if (control.hasError('email')) {
      return 'Não conseguimos identificar este e-mail';
    }

    // fallback genérico
    return this.getTextInvalid(label);
  }


 static getCepFieldError(
    control: AbstractControl | null,
    label: string
  ): string {
    if (!control || !(control.invalid && (control.dirty || control.touched))) {
      return '';
    }

    // 1) Campo vazio
    if (control.hasError('required')) {
      return `Faltou digitar ${label}`;
    }

    // 2) Caracteres mínimos (8 caracteres)
    if (control.hasError('minlength')) {
      return `Termine de digitar ${label}`;
    }

    // 4) Formato inválido (letras/especiais)
    if (control.hasError('pattern')) {
      return 'Use apenas números, sem letras ou caracteres especiais';
    }

    // 3) CEP inválido (retorno da API / validador customizado -> { invalidCep: true })
    if (control.hasError('invalidCep')) {
      return 'Informe um CEP válido';
    }

    return this.getTextInvalid(label);
  }

}
